<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon points="6,1 1,5 1.6,5.8 6,2.3 10.4,5.8 11,5" />
</svg>
</template>